import { Injectable, inject } from '@angular/core';
import { Observable, map, startWith } from 'rxjs';
import { APP_ENV } from 'apps/cmg-clear2-ui/src/environments/environment.model';
import { FeatureFlagRepository } from '../core/state/feature-flag.repository';
import { AppSettingsService } from '../shared/services/app-settings.service';

export interface LibreChatAgent {
  name: string;
  url: string;
}

// ApiAppSetting: "LibreChatConfig"
export interface LibreChatConfig {
  baseUrl: string;
  agents: { name: string; agentId: string }[];
}

@Injectable({
  providedIn: 'root',
})
export class LibreChatService {
  private readonly _environment = inject(APP_ENV);
  private readonly _featureFlagRepository = inject(FeatureFlagRepository);
  private readonly _appSettingsService = inject(AppSettingsService);

  /** Requires **enabled** ApiAppSetting `LibreChatConfig`. */
  getAgents$(): Observable<LibreChatAgent[]> {
    return this._getLibreChatConfig$().pipe(
      map((libreChatConfig) => {
        if (!libreChatConfig) {
          return [];
        }

        return libreChatConfig.agents.map((agent, index) => ({
          name: agent.name || `AI Agent ${index + 1}`,
          url: `${libreChatConfig.baseUrl}${agent.agentId}`,
        }));
      }),
    );
  }

  openAgent(agent: LibreChatAgent): void {
    window.open(agent.url, '_blank', 'noopener,noreferrer');
  }

  /** Derived from ApiAppSetting `LibreChatConfig`. */
  private _getLibreChatConfig$(): Observable<LibreChatConfig> {
    // Provided start value of null, in case observable never emits a value (internal edge case).
    return this._appSettingsService.getApiAppSettingByName$('LibreChatConfig').pipe(startWith(null));
  }
}
